import { Flex, Image, Text } from '@chakra-ui/react';
import React, { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../provider';
import { PATHS } from '../../../router/routes';
import leftIcon from '../../../assets/icons/left-icon.svg';

const LogoutButton = ({ variant }) => {
    const router = useNavigate();

    const { signOut } = useAuth();

    const logoutHandler = useCallback(() => {
        signOut();
        router(PATHS.SIGN_IN);
    }, [signOut, router]);

    const typeButton = useMemo(
        () => ({
            mobile: {
                m: '20px 0px',
                display: { base: 'Flex', sm: 'none' },
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid #E2E8F0',
                borderRadius: '6px',
                onClick: logoutHandler,
                cursor: 'pointer',
                p: '0px 16px',
                w: '100%',
                zIndex: '2',
                h: '40px',
            },
            desktop: {
                display: { base: 'none', sm: 'flex' },
                alignItems: 'center',
                _hover: {
                    border: '1px solid #E2E8F0',
                },
                border: '1px solid white',
                borderRadius: '6px',
                onClick: logoutHandler,
                cursor: 'pointer',
                p: '0px 16px',
                w: { sm: '120px', md: '150px' },
                pos: 'absolute',
                top: '20px',
                right: '10px',
                zIndex: '2',
                h: '40px',
            },
        }),
        [logoutHandler]
    );
    return (
        <Flex {...typeButton[variant ?? 'desktop']}>
            <Image mr='8px' src={leftIcon} />
            <Text textAlign='left' fontSize='16px' fontWeight='600' lineHeight='24px'>
                Log out
            </Text>
        </Flex>
    );
};

export default LogoutButton;
